// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__2Ke9h","icon":"style_icon__3saxg","title":"style_title__2np5d","logo":"style_logo__3onxj","logoContainer":"style_logoContainer__3ikC6"};